import { RootState } from "~/store/rootReducer"

export const authSelector = (state: RootState) => state.auth
export const isOwnerSelector = (state: RootState) => state.isOwner
export const selectedProject = (state: RootState) => state.selectedProject;
